import { useFeatureGatePlanSuggestion } from '@frameio/plan-management/feature-gate/hooks';

export const useIsAssetLifecycleManagementEnabled = () => {
  return useFeatureGatePlanSuggestion('ASSET_LIFECYCLE_MANAGEMENT')
    ?.includedInCurrentPlan;
};
